import type { ReactNode } from 'react';

import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';

import { LegalEntityProvider } from './context/LegalEntityContext';
import { queryClient } from './query-client';
import { theme } from './theme';
import { MantineProvider } from '@mantine/core';
import { DatesProvider } from '@mantine/dates';
import { ModalsProvider } from '@mantine/modals';
import { Notifications } from '@mantine/notifications';

import '@mantine/core/styles.css';
import '@mantine/dates/styles.css';
import '@mantine/dropzone/styles.css';
import '@mantine/notifications/styles.css';
import '@mantine/schedule/styles.css';
import '@mantine/tiptap/styles.css';
import './global.css';

import ModalsConfiguration from './components/modals';

export const Providers = ({ children }: { children: ReactNode }) => (
  <QueryClientProvider client={queryClient}>
    <MantineProvider theme={theme} defaultColorScheme='light'>
      <Notifications position='top-right' />
      <DatesProvider settings={{ firstDayOfWeek: 1 }}>
        <LegalEntityProvider>
          <ModalsProvider modals={ModalsConfiguration}>{children}</ModalsProvider>
        </LegalEntityProvider>
      </DatesProvider>
    </MantineProvider>
    {import.meta.env.DEV && <ReactQueryDevtools initialIsOpen={false} />}
  </QueryClientProvider>
);
